import styled from 'styled-components'

import { FlexContainer, Button } from '../../styles/defaults'
import { minmedia, maxmedia } from '../../styles/media-queries'
import { bordergray } from '../../styles/colors'
import { Container as SearchInput } from '../../components/SearchInput/styles'

// PageTitle
export const PageTitleContainer = FlexContainer.extend`
  align-items: center;
  margin-top: 1rem;
  margin-bottom: 1rem;

  ${minmedia.medium`
    margin-top: 1.5rem;
    margin-bottom: 1.5rem;
  `} ${minmedia.large`
    margin-top: 0;
    margin-bottom: 2rem;
  `};
`

export const PageTitle = styled.h1`
  margin: 0;
  font-weight: 400;
  font-size: 22px;

  ${minmedia.large`
    font-size: 36px;
  `};
`

export const NewButton = Button.extend`
  span:last-child {
    display: none;
  }

  ${minmedia.large`
    padding: 1rem 1.5rem;

    span:first-child {
      display: none;
    }
    span:last-child {
      display: inline;
    }
  `};
`

// Info
export const InfoContainer = FlexContainer.extend`
  align-items: center;
  margin-bottom: 1rem;
  border-top: 1px solid ${bordergray};
  border-bottom: 1px solid ${bordergray};

  ${minmedia.medium`
    margin-bottom: 1.5rem;
    padding: 1rem 4%;
  `} ${minmedia.large`
    margin-bottom: 2rem;
    padding: 2rem 0;
  `};
`

export const CompanyInfo = styled.div`
  width: 100%;
  padding: 1rem 4%;

  div:first-child {
    margin-bottom: 0.5rem;
  }

  ${minmedia.medium`
    width: 50%;
    padding: 0; //reset
  `} ${minmedia.large`
    display: flex;
    flex-wrap: wrap;

    div:first-child {
      margin-bottom: 0;
      margin-right: 4rem;
    }
  `};
`

export const SearchContainer = styled.div`
  width: 100%;
  padding: 1rem 4%;
  border-top: 1px solid ${bordergray};

  ${maxmedia.large`
    ${SearchInput} {
      width: 100%;
    }
  `} ${minmedia.medium`
    border: 0; //reset
    padding: 0; //reset
    width: 50%;

    ${SearchInput} {
      margin-left: auto; //align right
    }
  `};
`



// WEBPACK FOOTER //
// ./src/containers/Members/styles.js